import Channels from "../icons/channels.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlLabelButton } from "./PlayerControlLabelButton";

const ChannelsButton = () => {
  const translations = useTranslations();

  const sendToggleEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
    document.dispatchEvent(new CustomEvent("toggleChannelsOverlay"));
  };

  return (
    <PlayerControlLabelButton
      onClick={sendToggleEvent}
      disabled={false}
      Icon={<Channels />}
      label={translations("channels")}
      hoverText={translations("channels")}
    />
  );
};

export { ChannelsButton };
